import React, { useContext, useEffect, useState } from "react";
import {
  View,
  TouchableOpacity,
  FlatList,
  Dimensions,
  Text,
} from "react-native";
import ProgressBar from "../../components/progress-bar";
import Wrapper from "../../components/wrapper";
import LoginContext from "../../hooks/loginContext";
import { tasks } from "../../utils/tasks";
import {
  getCompletedTasksForUser,
} from "../../utils/user";
import { TranslateText } from "../../components/translate-text";

const TaskList = ({ setIndex, setTask }) => {
  const [completedTasks, setCompletedTasks] = useState([]);
  const {user} = useContext(LoginContext);
  useEffect(()=>{
    getCompletedTasks();
  },[])

  const isTaskCompleted = (task) => {
    if (completedTasks.length > 0) {
      const taskIdIndex = completedTasks.findIndex(
        (t) => t.done_task_id == `t${task.id}` || t.done_task_id == `${task.id}`
      );
      if (taskIdIndex >= 0) {
        return true;
      }
    }
    return false;
  };

  const computeN = (task) => {
    if(process.env.NODE_ENV == "development") {
      return 0;
    }
    if (task) {
      let curr_time = (new Date()).getTime();
      let start_time = new Date(user.created_date).getTime();
      // if curr_time > start_date
      if(curr_time > start_time) {
        if((curr_time - start_time)/(24*60*60*1000) >= parseInt(task.day)){
          return 0;
        } else {
          return parseInt(task.day) -  Math.floor((curr_time - start_time)/(24*60*60*1000));
        }
      }
    }
    return 0;
  };

  const getCompletedTasks = async () => {
    const completedTasks = await getCompletedTasksForUser(user.user_id);
    setCompletedTasks(completedTasks ? completedTasks : []);
  };

  return (
    <Wrapper>
      <TranslateText
        style={{
          fontSize: 28,
          marginVertical: 8,
          top: 60,
          width: "100%",
          textAlign: "center",
        }}
      >
        Hollo DigiACT
      </TranslateText>
      <View
        style={{
          height: "90%",
          padding: 12,
          paddingHorizontal: 0,
          alignItems: "flex-start",
          justifyContent: "center",
          paddingTop: 40,
          width: "100%",
        }}
      >
        <View
          style={{
            backgroundColor: "#FFF",
            paddingHorizontal: 8,
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            width: "100%",
            shadowColor: "rgba(0,0,0)",
            shadowOpacity: 0.2,
            marginBottom: 8,
            shadowOffset: { height: 0 },
          }}
        >
          <TranslateText
            style={{
              fontWeight: "700",
              fontSize: 16,
              lineHeight: 19,
              paddingVertical: 12,
            }}
          >
            Psychoeducation Journey
          </TranslateText>
        </View>
        <ProgressBar
          completed_tasks={completedTasks.length}
          total_tasks={tasks.length}
        />
        <FlatList
          showsVerticalScrollIndicator={true}
          style={{
            width: "100%",
            backgroundColor: "transparent",
            paddingBottom: 100,
            maxHeight: Dimensions.get("window").height / 1.5,
          }}
          data={tasks}
          renderItem={({ item }) => {
            const n = computeN(item);
            return (
              <View
                style={{
                  marginVertical: 8,
                  backgroundColor: "#D8D8D8",
                  width: "100%",
                  flexDirection: "row",
                  padding: 12,
                  justifyContent: "space-between",
                  alignItems: "center",
                  shadowColor: "rgba(0,0,0)",
                  shadowOpacity: 0.2,
                }}
              >
                <TranslateText>
                  <TranslateText style={{ textTransform: "capitalize" }}>
                    {`Task `}
                  </TranslateText>
                  {Number(item.id) + 1}
                </TranslateText>
                {isTaskCompleted(item) ? (
                  <CompleteButton />
                ) : n == 0 ? (
                  <StartButton
                    setIndex={setIndex}
                    setTask={setTask}
                    task={item}
                  />
                ) : n > 0 ? (
                  <LockedButton task={item} n={n} />
                ) : null}
              </View>
            );
          }}
        />
        <View
          style={{
            backgroundColor: "#FFF",
            paddingHorizontal: 8,
            borderBottomLeftRadius: 12,
            borderBottomRightRadius: 12,
            width: "100%",
            shadowColor: "rgba(0,0,0)",
            shadowOpacity: 0.2,
            marginTop: 8,
            shadowOffset: { height: 0 },
            height: 20,
          }}
        ></View>
      </View>
    </Wrapper>
  );
};

const StartButton = ({ setIndex, task, setTask }) => {
  return (
    <TouchableOpacity
      onPress={() => {
        setIndex(4);
        setTask(task);
      }}
      style={{
        backgroundColor: "#33CF71",
        borderRadius: 20,
        marginTop: 8,
        padding: 4,
      }}
    >
      <View style={{ alignItems: "center" }}>
        <TranslateText style={{ color: "#FFF", fontSize: 11 }}>START</TranslateText>
      </View>
    </TouchableOpacity>
  );
};

export const CompleteButton = () => {
  return (
    <TouchableOpacity
      onPress={() => {}}
      style={{
        backgroundColor: "transparent",
        borderRadius: 20,
        marginTop: 8,
        padding: 4,
      }}
    >
      <View style={{ alignItems: "center" }}>
        <TranslateText style={{ color: "#000", fontSize: 11 }}>Complete</TranslateText>
      </View>
    </TouchableOpacity>
  );
};

export const LockedButton = ({ n }) => {
  return (
    <TouchableOpacity
      onPress={() => {}}
      style={{
        backgroundColor: "#4A4A4A",
        borderRadius: 20,
        marginTop: 8,
        padding: 4,
        paddingHorizontal: 12,
      }}
    >
      <View style={{ alignItems: "center" }}>
        <TranslateText style={{ color: "#FFF", fontSize: 11 }}>
          Unlocks in {n} day(s)
        </TranslateText>
      </View>
    </TouchableOpacity>
  );
};

export default TaskList;
